export default "https://statics.cloudfastin.top/static/v1.27.34/store/images/sharing1.jpg?a65b424aa7be4ea8a3b144fd5dfa031c";